import * as React from "react";

import { graphql, useStaticQuery } from "gatsby";

import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { TWITTER_HANDLE } from "../constants";
import DummyImage from "../images/dummy.png";

function Seo({
  description,
  lang,
  title,
  keywords,
  noIndex,
  schemaMarkup,
  image: metaImage,
  pagePath,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            siteUrl
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const defaultTitle = site.siteMetadata?.title;
  const image = metaImage || DummyImage;
  const renderedTitle = title || defaultTitle;
  const pageUrl = new URL(pagePath, site.siteMetadata.siteUrl).toString();

  const additionalMetadata = [];

  if (noIndex) {
    additionalMetadata.push({
      name: `robots`,
      content: `noindex`,
    });
  }

  if (metaImage) {
    additionalMetadata.push(
      ...[
        {
          property: "og:image",
          content: image,
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ]
    );
  } else {
    additionalMetadata.push({
      name: "twitter:card",
      content: "summary",
    });
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={renderedTitle}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          name: `google-site-verification`,
          content: `udx54Og3Qy7teNLClOGVKYiX8LQywMHr4EOOO-XctUs`,
        },
        {
          name: `keywords`,
          content: keywords,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: pageUrl,
        },
        {
          property: `og:site_name`,
          content: `KnowESG`,
        },
        {
          name: `twitter:site`,
          content: `@${TWITTER_HANDLE}`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        ...additionalMetadata,
      ]}
    >
      {schemaMarkup && (
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      )}
    </Helmet>
  );
}

Seo.defaultProps = {
  lang: `en`,
  description: ``,
};

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }),
  pathname: PropTypes.string,
};

export default Seo;
